// @flow
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { hot } from 'react-hot-loader'
import './styles.scss'

import Masthead from '@ta-interaktiv/react-masthead'
import Scrollchor from 'react-scrollchor'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import UserFeedback from '@ta-interaktiv/react-user-feedback'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import { Waypoint } from 'react-waypoint'
import ShareButtons, { displayTypes } from '@ta-interaktiv/react-share-buttons'
import Quiz from '../quiz'

type Props = {
  articleId: string
}

class AppComponent extends Component<Props> {
  static defaultProps = {
    articleId: '13930976'
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch mediaName='24heures' />
        <Masthead articleID={this.props.articleId} />

        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Êtes-vous un pro de la lutte contre le blanchiment d’argent?
            </h1>

            <Waypoint
              scrollableAncestor={window}
              onLeave={event => {
                if (event.currentPosition === Waypoint.above) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'startReading'
                  })
                }
              }}
            />

            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                La nouvelle fuite de données «Troika-Laundromat» révèle comment
                des banques suisses ont accepté des millions d’origine douteuse.
                Auriez-vous refusé de faire transiter ces versements? Faites
                notre test du parfait banquier anti blanchiment – avec des cas
                qui ont réellement existés.
              </div>
            </h2>
            <p className='ta author'>
              <strong>Christian Brönnimann et Patrick Vögeli</strong>
            </p>
          </div>

          <div className='animation-container'>
            <iframe
              src='https://interaktiv.tagesanzeiger.ch/2019/geldwaescherei-quiz/header/geldwaesche.html'
              frameBorder='0'
              allowtransparency='true'
              allowFullScreen='allowfullscreen'
              webkitallowfullscreen='webkitallowfullscreen'
              mozallowfullscreen='mozallowfullscreen'
              oallowfullscreen='oallowfullscreen'
              msallowfullscreen='msallowfullscreen'
              width='100%'
              scrolling='no'
              style={{ overflow: 'hidden' }}
              className='mobile hidden'
            />

            <iframe
              src='https://interaktiv.tagesanzeiger.ch/2019/geldwaescherei-quiz/header/geldwaesche_2_mobile.html'
              frameBorder='0'
              allowtransparency='true'
              allowFullScreen='allowfullscreen'
              webkitallowfullscreen='webkitallowfullscreen'
              mozallowfullscreen='mozallowfullscreen'
              oallowfullscreen='oallowfullscreen'
              msallowfullscreen='msallowfullscreen'
              width='100%'
              scrolling='no'
              style={{ overflow: 'hidden' }}
              className='mobile only'
            />
          </div>
        </header>

        <div className='ui text container'>
          <p>
            Vous êtes le chef de l’unité de lutte contre le blanchiment d'argent
            dans une banque suisse. Chaque jour, des paiements suspects arrivent
            sur votre bureau: quelqu'un essaie peut-être de blanchir de l'argent
            dans votre banque et c’est à vous de décider comment réagir.
          </p>
          <p>
            Les blanchisseurs aiment cacher en Suisse des fonds d’origine
            criminelle. Dans leurs relations avec les banques, ils font comme
            s'ils transféraient des sommes de provenance légale. Ils présentent
            des contrats de vente, des factures ou autres documents, qui sont
            censés prouver que tout est en règle. Mais ces pièces sont-elles
            suffisantes?
          </p>
          <p>
            Nous vous montrons un certain nombre de cas réels, avec de vrais
            documents provenant de la nouvelle fuite de données
            “Troïka-Laundromat”. Vous devez décider si vous acceptez ou non
            l'argent dans votre banque.
          </p>

          <p>
            Dans chacun de ces cas, l'expéditeur de l'argent est la banque
            lituanienne Ukio. Elle se trouvait au centre d'un vaste système via
            lequel des milliards d’origine russe douteuse ont été transférés
            dans des banques occidentales (
            <a href='https://www.24heures.ch/24531700' target='_blank'>
              <i className='icon external alternate' />
              De faux contrats ont fait couler les millions russes en Suisse
            </a>
            ). À chaque fois que vous vous prononcerez sur un de ces cas, Daniel
            Thelesklaf, expert en lutte contre le blanchiment d'argent,
            expliquera si vous avez agi correctement ou non. Et nous vous dirons
            ce que la banque suisse en question a fait à l'époque.
          </p>
          <p>
            En bon banquier suisse, votre but est de respecter la loi.
            Saurez-vous arrêter les tentatives de blanchiment d’argent?
          </p>
          <p>À vous de jouer!</p>
        </div>

        <main className='ui vertical fitted segment'>
          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>
          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Cas N°1</h2>
            <span className='pretext'>
              De curieux contrats pour des machines
            </span>
          </div>

          <div className='ui text container'>
            <Quiz
              qId='quiz-0'
              articleId='13930976'
              solution='nein'
              imageTitle='bixman_1'
              titleDocument='Document original'
              descriptionDocument='(Cliquer pour agrandir)'
              filenameDocument='bixman_1.png'
              question='Acceptez-vous l’argent?'
              textOneTitle='D’où vient l’argent?'
              textOne='Une société écran panaméenne dispose d’un compte dans votre
              banque. 3,1 millions d’euros y atterrissent, répartis en cinq
              tranches. La somme est payée par une autre société boîte aux
              lettres, basée cette fois au Belize, un petit pays d’Amérique
              centrale. Mais le compte en banque de cette société se trouve
              à la Ukio Bank en Lituanie. Tout est clair jusque-là?'
              textTwoTitle='La justification des paiements'
              textTwo='Pour prouver que les paiements sont basés sur une transaction
              légale, votre client soumet deux contrats d’achat identiques. Ils indiquent
              que des machines d’une valeur totale de trois millions d’euros ont été
              vendues.'
              textThreeTitle='Le problème'
              textThree={
                <>
                  Dans les deux contrats, la société de boîte aux lettres du
                  Panama qui a ce compte auprès de votre banque est désignée
                  comme{' '}
                  <span style={{ borderBottom: 'solid 2px' }}>l'acheteuse</span>
                  . Votre client devrait donc payer lui-même les 3,1 millions,
                  et non les recevoir.
                </>
              }
              expertentext='Quel employé de commerce un peu sérieux dépenserait des
              millions sur la base d’une telle facture? Cela ne fait aucun sens
              économique. Les documents sont très probablement des factures
              fictives. Et en plus, l’argent vient de Lituanie, un pays qui connaît
              des problèmes considérables en matière de supervision bancaire. Je ne
              créditerais pas l’argent sur le compte du client et je le renverrais, même
              si les montants ne sont pas anormalement élevés.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Malgré ces contrats erronés, l’argent de l’entreprise bélizienne
              est parvenu à la VP Bank à Zurich sans que cela soit contesté. Quatre tranches
              en avril 2010, une tranche en septembre 2010.'
            />
          </div>

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>
          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Cas N°2</h2>
            <span className='pretext'>
              Un système de climatisation à prix très variable
            </span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-1'
              articleId='13930976'
              solution='nein'
              imageTitle='castle_2'
              titleDocument='Document original'
              descriptionDocument='(Cliquer pour agrandir)'
              filenameDocument='castle_2.png'
              documentIsWide
              question='Acceptez-vous l’argent?'
              textOneTitle='D’où vient l’argent?'
              textOne='Cette fois-ci, 5 millions de dollars doivent être transférés dans
              votre banque. Encore une fois, l’argent provient d’une société boîte aux
              lettres du Belize ayant un compte à la Ukio Bank en Lituanie.'
              textTwoTitle='La justification du paiement'
              textTwo='Dans ce dossier, l’entreprise du Belize aurait acheté des
              climatiseurs à votre client. Elle veut le prouver avec toute une série de
              factures qu’elle vous présente.'
              textThreeTitle='Le problème'
              textThree='Beaucoup de ces factures sont pratiquement identiques. Avec les
              mêmes climatiseurs, le prix est le même, mais le prix est parfois fixé en
              dollars américains, parfois euros. Les prix des mêmes machines fluctuent
              donc de plus d’un quart – en quelques jours. En plus, le calcul du montant
              total est faux sur plusieurs factures.'
              expertentext='Ici aussi, il y a toute une série de facteurs de risque et il est
              fort probable qu’il s’agit de factures fictives. Je n’aurais pas accepté ces
              paiements. Un employé de commerce sérieux ne se trompe pas comme ça de
              devise. Sur la base de ces documents, je rejetterais également les paiements
              futurs.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Les quelque 5 millions de dollars sont arrivés sans contestation
              chez UBS en douze tranches, entre août 2009 et décembre 2009.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>
          <div className='ui text container'>
            <h5 className='continueTitle'>La suite de ce cas:</h5>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-2'
              articleId='13930976'
              solution='nein'
              question='Acceptez-vous ces versements?'
              textOne='Deux ans plus tard, depuis ce même compte dans votre banque, de l’argent
              est reversé aux présumés acheteurs de climatiseurs du Belize. Cette fois, selon
              de nouvelles factures, des appareils électroniques auraient été vendus à votre
              clients. Au total, près de deux millions de dollars doivent être versés.'
              expertentext='Dans ce cas, j’empêcherais carrément la sortie des fonds de la
              banque. En plus de la facture fictive et des divergences concernant la devise, il
              y a une autre indication de blanchiment d’argent: l’inversion des rôles - acheteur
              et vendeur - sans raison apparente. Et pour ne rien arranger, se pose la question
              de savoir quel rôle une société d’Amérique centrale doit jouer dans de telles
              transactions commerciales.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Ces deux millions de dollars ont été versés par UBS à l’entreprise
              bélizienne en décembre 2011.'
            />
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_grey.svg')}
              alt=''
              className='icon step'
            />
          </div>

          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Cas N°3</h2>
            <span className='pretext'>
              Du matériel de construction pour la Lituanie
            </span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-3'
              articleId='13930976'
              solution='ja'
              descriptionDocument='(Cliquer pour agrandir)'
              filenameDocument='geldwaescherei_document_2.png'
              question='Acceptez-vous l’argent?'
              textOneTitle='D’où vient l’argent?'
              textOne='Vous êtes inquiets. Le compte d’une entreprise panaméenne auprès de votre
              banque reçoit constamment d’importants paiements, pour un total de huit millions
              de dollars. L’argent provient d’une boîte aux lettres anonyme dans les îles
              Vierges britanniques (BVI) dont vous n’avez jamais entendu parler auparavant. Là
              encore, le paiement s’effectue par l’intermédiaire de l’Ukio Bank.'
              textTwoTitle='La justification du paiement'
              textTwo='Votre client vous présente des contrats de vente de matériaux de
              construction. En plus des contrats, vous disposez également de documents
              douaniers en provenance de Lituanie avec un cachet officiel pour les
              documents d’importation et de fret pour le transport des matériaux.'
              textThreeTitle='Le problème'
              textThree='C’est seulement après plusieurs relances de votre banque que votre
              client a présenté les documents de douane et de fret.'
              expertentext='Dans ce cas, la banque a procédé avec suffisamment de prudence. Elle
              a demandé des documents supplémentaires pour vérifier les flux de trésorerie et a
              fait ce qu’une banque peut faire avec un effort raisonnable. De cette façon, elle
              peut accepter l’argent.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Ce cas est un cas fictif… Il montre toutefois comment une banque
              peut vérifier la légitimité d’un paiement.'
            />
          </div>

          <div className='ui container question-header'>
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
            <img
              src={require('./imgs/money_blue.svg')}
              alt=''
              className='icon step'
            />
          </div>

          <div className='ui container subtitleWrapper'>
            <h2 className='story-step'>Cas N°4</h2>
            <span className='pretext'>
              Un ping-pong de reconnaissances de dette
            </span>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-4'
              articleId='13930976'
              solution='nein'
              imageTitle='dickinson_1'
              titleDocument='Document original'
              descriptionDocument='(Cliquer pour agrandir)'
              filenameDocument='dickinson_1.png'
              documentIsWide
              question='Acceptez-vous l’argent?'
              textOneTitle='D’où vient l’argent?'
              textOne='Deux sociétés boîtes aux lettres des îles Vierges britanniques
              continuent de renvoyer de l’argent de l’une vers l’autre. L’une a un
              compte auprès de votre banque, l’autre auprès de la Ukio Bank. Sur près
              de 200 transferts, 36 millions de dollars vont dans un sens et 56 millions
              de dollars dans l’autre.'
              textTwoTitle='La justification du paiement'
              textTwo='Les paiements sont justifiés dans les deux sens par des reconnaissances
              de dette libellées de manière identique, que les deux sociétés se revendent
              mutuellement. Dans le cas de la société ayant un compte auprès votre banque, ce
              n’est pas le propriétaire de la société qui signe, mais une personne disposant
              d’une procuration générale.'
              expertentext='Ces transactions doivent être refusées dans tous les cas. Outre
              les indices de blanchiment d’argent déjà mentionnés, il existe d’autres facteurs
              qui soulèvent des soupçons: le montant et la fréquence des opérations, les
              opérations de va-et-vient («entrées et sorties») et l’existence d’une procuration
              individuelle et en blanc.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Les transactions décrites ont bel et bien eu lieu entre février
              2008 et avril 2012. UBS les a autorisées sur l’un de ses comptes en Suisse.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>
          <div className='ui text container'>
            <h5 className='continueTitle'>La suite de ce cas:</h5>
          </div>

          <div className='ui text container quiz'>
            <Quiz
              qId='quiz-5'
              articleId='13930976'
              solution='nein'
              imageTitle='dickinson_2'
              titleDocument='Document original'
              descriptionDocument='(Cliquer pour agrandir)'
              filenameDocument='dickinson_2.png'
              question='Acceptez-vous l’argent?'
              textOneTitle='D’où vient l’argent?'
              textOne='Un montant additionnel de 1,5 million de dollars provenant d’une autre
              société offshore du Belize arrive sur le compte de la même société auprès de
              votre banque.'
              textTwoTitle='La justification du paiement'
              textTwo='L’entreprise produit un contrat de “services juridiques”. Le contrat
              de deux pages fixe la valeur maximale des services à exactement 1,5 million
              de dollars.'
              textThreeTitle='Le problème'
              textThree='Selon le contrat, les services ne doivent être payés qu’après avoir
              été fournis et dûment facturés. Mais les 1,5 million de dollars parviennent à
              votre banque 12 jours seulement après la signature du contrat.'
              expertentext='“De tels contrats de service fictifs sont souvent utilisés pour
              induire la banque en erreur. Là encore, la question est de savoir si les
              transactions sont formulées de façon habituelle ou non. Dans le cas des
              services juridiques en particulier, les contrats doivent être rédigés
              selon les normes. Il n’est pas réaliste que le prix soit fixé d’avance, avant
              même de savoir quels services seront fournis et dans quelle envergure! À
              cela s’ajoute l’implication de trois pays à risque (Lituanie, Belize et BVI). Je
              n’effectuerais ces transactions sous aucun prétexte.'
              realCaseTitle='Ce qui s’est réellement passé'
              realCaseText='Ce transfert est arrivé sur le compte chez UBS le 11 avril
              2012. Il s’agit du transfert le plus récent sur ce compte qui soit documenté
              par la fuite de données. Il est donc possible que le compte ait malgré tout
              été clôturé.'
            />
          </div>

          <p className='spaced'>&nbsp;</p>

          {/*
          <div className='ui container question-header'>
            <div className='question-headerIcons'>
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_blue_2.svg')} alt='' className='icon step' />
              <img src={require('./imgs/money_grey_2.svg')} alt='' className='icon step' />
            </div>

            <div className='question-headerContent'>
              <h2 className='story-step'>Fall 4</h2>
              <p className='pretext'>Modems</p>
            </div>
          </div>

          */}

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'contentBottom'
                })
              }
            }}
          />
        </main>

        {/* User-Feedback */}
        <div
          className='ui vertical fitted segment user-feedback'
          style={{ borderTop: '1px solid rgba(0,0,0,.15)' }}
        >
          <div
            className='ui text container infographic user-feedback-container'
            style={{ margin: '0 auto', padding: '2em 0 1em' }}
          >
            <UserFeedback
              locale='fr'
              theme='simple'
              starIcon='star'
              articleId='13930976'
              starColor='blue'
              fontColor='#333'
              starAmount='5'
              title='Comment évaluez-vous ce contenu?'
              questions={[
                'Ce contenu était-il informatif?',
                'Était-il divertissant?',
                'Comment jugez-vous la présentation?'
              ]}
            />
          </div>
        </div>

        {/* Experte */}

        <div className='ui vertical fitted attached segment' id='methodik'>
          <div
            className='ui text container methodik'
            style={{ position: 'relative' }}
          >
            <h3>L’expert</h3>
            <p>
              Daniel Thelesklaf est actif dans la lutte contre le blanchiment
              d'argent depuis plus de vingt ans. Il a évalué les cas en sa
              qualité de Président de Moneyval, un comité d'experts sur le
              blanchiment d'argent du Conseil de l'Europe. Daniel Thelesklaf est
              actuellement chef de l'Autorité de lutte contre le blanchiment
              d'argent au Liechtenstein. Dès août 2019, il dirigera le Bureau de
              communication en matière de blanchiment d'argent (MROS), rattaché
              à l’administration fédérale helvétique.
            </p>

            <h3>L’obligation des banques</h3>
            <p>
              Les banques suisses doivent examiner attentivement les
              transactions suspectes afin de réduire le risque de blanchiment
              d'argent. La loi sur le blanchiment d'argent oblige les banques à
              «clarifier l'arrière-plan et le but d'une transaction ou d'une
              relation d'affaires» si, entre autres, elles «paraissent
              inhabituelles» ou «comportent un risque accru». Au niveau de
              l'ordonnance, des exemples sont donnés qui peuvent indiquer des
              risques accrus, par exemple si des sociétés boîtes aux lettres
              sont impliquées dans une transaction, en particulier de
              l'étranger, ou si les transactions sont inhabituelles par leur
              montants.
            </p>
            <p>
              Dans le cas de transactions présentant des risques accrus, une
              banque doit procéder à des clarifications supplémentaires à un
              coût raisonnable. Il s'agit, entre autres, de vérifier “la
              plausibilité des informations obtenues”.
            </p>
            <p>
              Ces obligations étaient déjà formulées de manière très similaires
              entre 2009 et 2013, la période dont proviennent les exemples de
              notre jeu.
            </p>
            <p>
              Si les banques soupçonnent que de l'argent a pu être blanchi par
              un virement, elles sont tenues de le signaler au Bureau de
              communication en matière de blanchiment d'argent (MROS). On ne
              sait pas si de telles annonces ont été faites dans les cas décrits
              ici.
            </p>

            <h3>Ce que disent les banques</h3>
            <h4>UBS</h4>
            <p>
              En raison de la loi et de la réglementation, nous ne pouvons pas
              nous prononcer sur des cas individuels ou sur le fait que ces
              personnes sont ou ont été nos clients. UBS respecte toutes les
              lois partout où elle est active. Nous ne tolérons aucun abus et
              investiguons sur chaque indice d’activité douteuse.
            </p>
            <p>
              Pour l’analyse de transactions suspectes, UBS utilise un système
              sophistiqué d’outils de surveillance électroniques et forme
              régulièrement son personnel à tous les aspects de la lutte contre
              le blanchiment.
            </p>
            <p>
              Nous signalons régulièrement les activités suspectes aux autorités
              compétentes dans la lutte contre le blanchiment d’argent.
            </p>

            <h4>VP Bank</h4>
            <p>
              Nous ne donnons pas d’informations sur notre clientèle. Nous
              aimerions toutefois préciser ce qui suit:
            </p>
            <p>
              VP Bank (Suisse) SA est soumise à la loi suisse contre le
              blanchiment d’argent et à la surveillance des marchés financiers
              (FINMA) et applique à tout moment les prescriptions légales. Notre
              département de compliance est indépendant et analyse le respect
              des prescriptions réglementaires en fonction du risque. S’il
              existe des indices de blanchiment, il examine et annonce ces cas
              de manière proactive dans le cadre de son devoir d’annonce. Pour
              la prévention du blanchiment, des actes préalables au blanchiment,
              de la criminalité organisée et du financement du terrorisme, la VP
              Bank (Suisse) SA utilise un logiciel de surveillance pour
              identifier les transactions et les comportements inhabituels.
            </p>
          </div>
        </div>

        {/* footer */}
        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable grid'>
              {/* <div className='center aligned row teaser-section'>
                <a href='/'>
                  <img
                    src='https://interaktiv.tagesanzeiger.ch/inline-teaser.gif'
                    className='portfolio-teaser'
                  />
                </a>
            </div> */}
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small infographic table'>
                    <tbody>
                      <tr style={{ paddingTop: '0.3em' }}>
                        <td>Texte et recherches</td>
                        <td>Christian Brönnimann et Oliver Zihlmann</td>
                      </tr>
                      <tr>
                        <td>Programmation et conception digitale</td>
                        <td>Patrick Vögeli</td>
                      </tr>
                      <tr>
                        <td>Publication</td>
                        <td>
                          <TimestampFormatter timestamp={1551762000} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className='column'>
                  <FeedbackMessage
                    question='Vous voulez communiquer un renseignement ou vous avez repéré une erreur?'
                    call='Envoyez-nous un message à '
                    mailTo='24heures.web@sr.tamedia.ch'
                  />
                  <div className='ui fluid share aligned container'>
                    <ShareButtons
                      articleID={this.props.articleId}
                      displayType={displayTypes.VERTICAL_BUTTONS}
                    />
                  </div>
                </div>
              </div>

              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === Waypoint.below) {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'pageBottom'
                    })
                  }
                }}
              />

              <div className='center aligned row'>
                <div className='column last' style={{ margin: 'auto' }}>
                  <div className='ui fluid copyright container infographic'>
                    <PolymorphicCopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)
